module.exports = __webpack_public_path__ + "img/SPEDIMO_logo.2df736ef.svg";